Object.filter = function (obj, predicate) {
	var result = {},
		key;
	for (key in obj) {
		if (obj.hasOwnProperty(key) && predicate(obj[key])) {
			result[key] = obj[key];
		}
	}

	return result;
};

const hasValue = (state) => {
	if (state) {
		return Boolean(state.value)
	}
	return false;
}

const returnValue = (state) => {
	return state.value
}

const validateEmail = (email) => {
	let pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return pattern.test(email);
}

const checkInput = (state, errorCallback) => {

	if (!state) return;

	const errors = {
		FullName: "יש למלא שם",
		Email: "יש למלא מייל תקין",
		Age: "יש למלא גיל",
		Gender: "יש לבחור מין",
		PhoneNumber: "יש להזין מספר טלפון תקין",
		FileName: "לא נבחר קובץ",
		PlainText: "נא ספרו לנו:",
		PlainText2: "יש למלא כתובת",
		ExtraField1: "שם ההורה",
		ExtraField2: "שם הילד",
		TOS: " "
	}

	switch (state.name) {
		case "FullName":
		case "ExtraField1":
		case "ExtraField2":
			if (state.value.length < 2) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "PlainText":
		case "PlainText2":
			if (state.value .length < 2 || state.value.length > 2883) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Age":
			if (state.value.length < 1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Gender":
			if (state.value == -1) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "PhoneNumber":
			if (state.value.length < 9 || state.value.length > 12) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "Email":
			if (!validateEmail(state.value)) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "TOS":
			if (state.value != 1) {
				alert("עליך לאשר את הסכמתך לתקנון על מנת להמשיך");
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
		case "FileName":
			if (!state.value) {
				errorCallback(state, errors[state.name]);
				return false;
			}
			break;
	}
	return true;
}

export {
	validateEmail,
	returnValue,
	hasValue,
	checkInput

}


// WEBPACK FOOTER //
// ./src/Components/Services/Validation.js